<template>
  <v-dialog v-model="dialog" width="350px">
    <v-card class="product-group-dialog">
      <v-card-title class="grey lighten-2 text-uppercase pt-3 pb-3">
        {{ menuGroup.name }}
      </v-card-title>
      <div class="modal-content">
        <v-card-text v-if="starters.length > 0">
          <h3>{{ $t("common.first") }}</h3>
          <v-row>
            <v-col cols="12">
              <ul>
                <li v-for="(starter, index) in starters" :key="index">
                  {{ starter.name }}
                </li>
              </ul>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-text v-if="maincourse.length > 0 && !menuGroup.isStarter">
          <h3>{{ $t("common.second") }}</h3>
          <v-row>
            <v-col cols="12">
              <ul>
                <li v-for="(maincourse, index) in maincourse" :key="index">
                  {{ maincourse.name }}
                </li>
              </ul>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-text v-if="menuGroup.isDessert && dessert.length > 0">
          <h3>{{ $t("common.dessert") }}</h3>
          <v-row>
            <v-col cols="12">
              <ul>
                <li v-for="(dessert, index) in dessert" :key="index">
                  {{ dessert.name }}
                </li>
              </ul>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-text v-if="menuGroup.isDrink && drinks.length > 0">
          <h3>{{ $t("common.drinks") }}</h3>
          <v-row>
            <v-col cols="12">
              <ul>
                <li v-for="(drink, index) in drinks" :key="index">
                  {{ drink.name }}
                </li>
              </ul>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="d-flex justify-center">
          <v-btn text @click="dialog = false">{{ $t("common.close") }}</v-btn>
        </v-card-actions>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "product-group-dialog",
  props: {
    menuGroup: Object,
    dessert: Array,
    starters: Array,
    maincourse: Array,
    drinks: Array,
    isAdmin: Boolean
  },
  data() {
    return {
      dialog: false
    };
  },
  methods: {
    open() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    }
  }
};
</script>

<style></style>
